import request, { IWorkspaceResponse, IListWorkspaceResponse } from '/@/api/http/request'
// import { ELocalStorageKey } from '/@/types'


/**
 * 获取飞行控制参数
 * @param params
 * @returns
 */
export async function getFlyNum (params: any, workspaceId: any) {
  const resp = await request.get(`/sysConfig/page?sysName=${params.sysName}&workspaceId=${workspaceId}`)
  return resp.data
}
/**
 * 修改飞行控制参数
 * @param params
 * @returns
 */
export async function updateFlyNum (body: any) {
  const resp = await request.post(`/sysConfig/update`, body)
  return resp.data
}
// 设置工地标记
export async function setBuildFlagApi (site: any) {
  const resp = await request.get(`my/user/setConstructionSite?constructionSite=${site}`)
  return resp.data
}
// 获取工地标记
export async function getBuildFlagApi () {
  const resp = await request.get(`my/user/getConstructionSite`)
  return resp.data
}